import {inject, Injectable, Signal, signal} from '@angular/core';
import {TelegramAccount} from "../types/telegram-page.types";
import {TelegramLoadFileService} from "./telegram-load-file.service";
import {defaultIcon} from "../configs/telegram-page-config";

@Injectable({
  providedIn: 'root'
})
export class TelegramAccountImagesService {
  private telegramLoadFileService: TelegramLoadFileService = inject(TelegramLoadFileService);
  private _accountImages = signal<Record<string, string>>({});
  private accountImages: Signal<Record<string, string>> = this._accountImages.asReadonly();

  public loadAccountPhotos(accounts: Array<TelegramAccount>): void {
    accounts?.forEach(async (account) => {
      account.photoRemoteId && await this.setImageUrls(account);
    });
  }

  public getAccountImage(id: string): string {
    return this.accountImages()[id] || defaultIcon;
  }

  public async setImageUrls(account: TelegramAccount, isUpdatePhoto?: boolean): Promise<void> {
    if (this._accountImages().hasOwnProperty(account.accountId) && !isUpdatePhoto) { return; }

    const url = await this.telegramLoadFileService.loadImage({
      remoteId: account.photoRemoteId,
      accountId: account.accountId
    });

    this._accountImages.update(current => ({
      ...current,
      [account.accountId]: url
    }));
  }
}
